import styled from 'styled-components'

const CustomerContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding-top: 60px;
  padding-bottom: 7rem;
  margin-left: 1em;
  margin-right: 1em;
`

export default CustomerContainer